<template>
  <span v-text="fullString" />
</template>

<script setup>
import { useI18n } from 'vue-i18n';

const { locale } = useI18n();
const $bct = inject('translator');

const haitianCreoleFormatting = {
  long: [
    'Janvye',
    'Fevriye',
    'Mas',
    'Avil',
    'Me',
    'Jen',
    'Jiyè',
    'Out',
    'Septanm',
    'Oktòb',
    'Novamn',
    'Desamn',
  ],
};

const props = defineProps({
  date: {
    type: String,
    default: null,
  },
  hideYear: Boolean,
  nulltext: {
    type: String,
    default: '',
  },
  prefix: {
    type: String,
    default: '',
  },
  prefixSeparator: {
    type: String,
    default: '',
  },
  suffix: {
    type: String,
    default: '',
  },
  shortMonth: {
    boolean: false,
    type: Boolean,
  },
  timezone: {
    default() {
      return Intl.DateTimeFormat().resolvedOptions().timeZone;
    },
    type: String,
  },
});

const fullString = computed(() => {
  const str = [];
  if (props.prefix) {
    str.push(`${$bct(props.prefix)}${props.prefixSeparator}`);
  }

  str.push(localeDateTimeString.value);

  if (props.suffix) {
    str.push($bct(props.suffix));
  }

  return str.join(' ');
});

const localeDateTimeString = computed(() => {
  if (!props.date) {
    return props.nulltext;
  }
  const date = new Date(props.date);
  const day = date.getUTCDate();
  const shouldShowTime = date.getMilliseconds() !== 0;

  if (locale.value === 'ht') {
    const month = haitianCreoleFormatting.long[date.getUTCMonth()];
    const year = date.getUTCFullYear();

    if (shouldShowTime) {
      const haitianTimeZone = date.toLocaleTimeString('ht', {
        timeZone: 'America/Port-au-Prince',
      });
      return `${day} ${month} ${year}, ${haitianTimeZone}`;
    } else {
      return `${day} ${month} ${year}`;
    }
  } else {
    const options = {
      month: props.shortMonth ? 'short' : 'long',
      day: 'numeric',
      timeZone: getTimeZone(),
    };

    if (shouldShowTime) {
      options.hour = 'numeric';
      options.minute = 'numeric';
    }

    if (!props.hideYear) {
      options.year = 'numeric';
    }
    return date.toLocaleDateString(locale.value, options);
  }
});

function getTimeZone() {
  if (props.timezone.includes('Etc/Unknown')) {
    return 'UTC';
  }
  return props.timezone;
}
</script>
